import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';

import { IEventSettings } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class MomentService {
    moment = moment;
    eventSettings: IEventSettings;

    getDateWithTimezone(date: string | Date, timezone: string): Date {
        const withTz = this.moment.tz(date, timezone);
        return new Date(withTz.year(), withTz.month(), withTz.date(), withTz.hour(), withTz.minute(), withTz.second());
    }

    toLocalDateTime(value: string | Date, locale: string, format: string): string {
        return this.moment(value).local().locale(locale).format(format);
    }

    toEventDateTime(value: string | Date, timezone: string, formatType?: 'date-time' | 'date' | 'time', eventSettings?: IEventSettings): string {
        eventSettings ||= this.getEventSettings();
        const fullDateString = typeof value === 'object' ? value.toISOString() : value;
        let format: string;
        if (formatType === 'date') {
            format = eventSettings.date_format;
        } else if (formatType === 'time') {
            format = eventSettings.time_format;
        } else {
            format = eventSettings.datetime_format;
        }
        let result: string;
        if (timezone) {
            result = this.moment(fullDateString).tz(timezone).format(format);
        } else {
            result = this.moment(fullDateString).format(format);
        }
        return result;
    }

    setEventSettings(settings: IEventSettings) {
        this.eventSettings = settings;
    }

    getEventSettings(): IEventSettings {
        return this.eventSettings;
    }

    getDateTimeWithTimezone(date: string | Date, timezone: string, dateTimeFormat?: string): string {
        return this.moment.tz(date, timezone).format(dateTimeFormat);
    }

    // formatDateTimeNoTimezone(dateTime: string, locale: string, dateTimeFormat: string): string {
    //     return this.moment(dateTime).locale(locale).format(dateTimeFormat);
    // }

    formatDateTime(dateTime: string, timezone: string, locale: string, dateTimeFormat: string): string {
        return this.moment.tz(dateTime, timezone).locale(locale).format(dateTimeFormat);
    }

    formatDate(date: string, locale: string, dateFormat: string): string {
        return this.moment(date).locale(locale).format(dateFormat);
    }

    formatTime(time: string, locale: string, timeFormat: string): string {
        return this.moment(time, 'hh:mm:ss').locale(locale).format(timeFormat || 'HH:mm');
    }
}
